import { ScreenTypes } from '../utils/ScreensList';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SiteExperienceConfiguration } from '@luckycart/xpn-types';

interface DisplayedScreen {
  displayError: boolean;
  displayedScreen: ScreenTypes;
  isLoading: boolean;
}

const initialState = {
  displayError: false,
  displayedScreen: ScreenTypes.HOME,
  isLoading: true,
};

export const displayedScreenSlice = createSlice({
  initialState,
  name: 'GameExperience',
  reducers: {
    transitionFromLoadingToFirstScreen (
      state: DisplayedScreen,
      { payload }: PayloadAction<{ 
        siteConfiguration: SiteExperienceConfiguration, 
        hasOnlyOneGame: boolean, 
        firstGameHasBeenPlayed: boolean,
        firstGameIsUnavailable: boolean,
        firstGameHasExpired: boolean,
      }>
    ) {
      let screenToDisplay = ScreenTypes.HOME;
      if (payload.firstGameIsUnavailable) {
        screenToDisplay = ScreenTypes.UNAVAILABLE;
      } else if (payload.firstGameHasBeenPlayed) {
        screenToDisplay = ScreenTypes.ALREADY_PLAYED;
      } else if (payload.firstGameHasExpired) {
        screenToDisplay = ScreenTypes.EXPIRED;
      } else if (payload.hasOnlyOneGame && payload.siteConfiguration.singleGame.activated) {
        screenToDisplay = ScreenTypes.SINGLEGAME;
      } else if (!payload.hasOnlyOneGame && payload.siteConfiguration.multiGame.activated) {
        screenToDisplay = ScreenTypes.MULTIGAME;
      } else if (payload.siteConfiguration.smartOptinsForm.activated) {
        screenToDisplay = ScreenTypes.SMART_COLLECT;
      } else if (payload.siteConfiguration.collect.activated) {
        screenToDisplay = ScreenTypes.COLLECT;
      }
      return {
        ...state,
        displayedScreen: screenToDisplay,
        isLoading: false,
      };
    },
    transitionAfterWelcomeScreen(state: DisplayedScreen, { payload }: PayloadAction<{ 
		collectScreenIsActivated: boolean, isSmartOptin: boolean
	}>) {
      if (payload.isSmartOptin) {
        return {
          ...state,
          displayedScreen: ScreenTypes.SMART_COLLECT,
        };
      } 
      return {
        ...state,
        displayedScreen: payload.collectScreenIsActivated
          ? ScreenTypes.COLLECT
          : ScreenTypes.HOME,
      };
    },
    transitionAfterCollectScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.HOME,
      };
    },
    transitionFromGameHomeToGameScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.GAME,
      };
    },
    transitionFromGameToGameResult (state: DisplayedScreen, { payload }: PayloadAction<{ hasWon: boolean }>) {
      return {
        ...state,
        displayedScreen: payload.hasWon
          ? ScreenTypes.WON
          : ScreenTypes.LOST,
      };
    },
    transitionFromGameResultToNextGame (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.HOME,
      };
    },
    displayErrorScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayError: true,
        displayedScreen: ScreenTypes.ERROR,
        isLoading: false,
      };
    },
    displayAlreadyPlayedScreen (state: DisplayedScreen) {
      return {
        ...state,
        displayedScreen: ScreenTypes.ALREADY_PLAYED,
        isLoading: false,
      };
    },
  },
});

const { actions, reducer } = displayedScreenSlice;

export const {
  transitionFromLoadingToFirstScreen,
  transitionAfterWelcomeScreen,
  transitionAfterCollectScreen,
  transitionFromGameHomeToGameScreen,
  transitionFromGameToGameResult,
  transitionFromGameResultToNextGame,
  displayErrorScreen,
  displayAlreadyPlayedScreen,
} = actions;
export default reducer;
